import React, { useEffect, useMemo } from 'react';
import withIntlProvider from './withIntlProvider';
import addTitle from './addTitle';
import { useDispatch, useSelector } from 'react-redux';
import { defaultProgramCode, defaultProgramName } from 'utils/constants';
import actions from 'state/actions';
import { useLocation } from 'react-router';
import selectors from 'state/selectors';

// This HOC can be used to decorate the wrapped module with
// runtime responsabilites
export default function initModule<P extends object>(
  Module: React.FunctionComponent<P>,
  programCode: number,
  programName?: string,
  programUrl?: string,
) {
  return function WrapperOfModuleToBeInitialized(props: P) {
    const dispatch = useDispatch();
    const { pathname } = useLocation();
    const idUser = useSelector(selectors.user.getIdUser) || -1;

    useEffect(() => {
      dispatch(actions.app.setProgramCode(programCode));
      dispatch(actions.app.setProgramName(programName || ''));
      dispatch(actions.app.setProgramUrl(programUrl ?? ''));
      dispatch(actions.app.setConfigurationsByCompaniesDocTypeUser());
      return () => {
        dispatch(actions.app.setProgramCode(defaultProgramCode));
        dispatch(actions.app.setProgramName(defaultProgramName));
        dispatch(actions.documents.setCurrentFilters([]));
        dispatch(actions.app.setCompanies([]));
        dispatch(actions.documents.setDocumentImageId(0));
        dispatch(actions.documents.setDocumentImage(''));
        dispatch(actions.documents.setActiveDocumentId([]));
      };
    }, [dispatch]);

    // configs, companies
    useEffect(() => {
      if (idUser) {
        dispatch(actions.app.setConfigs(idUser, programCode));
        dispatch(actions.app.setConfigurationsByCompanies(idUser, programCode));
      }
    }, [dispatch, idUser]);

    useEffect(() => {
      dispatch(actions.modal.closeModal());
    }, [pathname, dispatch]);

    // decorate here with new responibility
    const DecoratedModule = useMemo(
      () => addTitle(withIntlProvider(Module, programCode), programName || 'Lucy4Cloud'),
      [],
    );

    return (
      <>
        <DecoratedModule {...props} />
      </>
    );
  };
}
